export enum EventType {
  UNKNOWN = 1,
  STORING = 2,
  SELLING = 3,
  REPAIRING = 4,
  SHIPPING = 5,
  RECEIVING = 6,
  RETURNING = 7,
  THEFT = 8,
  RECALL = 9,
  REMOVAL = 10
}
